import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from '../auth-guard.service';
import { PremiumDueComponent } from './premium-due/premium-due.component';
import { MessagesComponent } from './messages/messages.component';
import { LapsedPoliciesComponent } from './lapsed-policies/lapsed-policies.component';
import { BirthDayRemindersComponent } from './birth-day-reminders/birth-day-reminders.component';
import { NotificationsTestApiStepFormComponent } from './notifications-test-api-step-form/notifications-test-api-step-form.component';

const routes: Routes = [
  {
    path: 'getBirthday',
    component: BirthDayRemindersComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'getLapsedPolicies',
    component: LapsedPoliciesComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'getMessages',
    component: MessagesComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'getPremiumDue',
    component: PremiumDueComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'notificationsAPI',
    component: NotificationsTestApiStepFormComponent,
    canActivate: [AuthGuardService],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NotificationRoutingModule {}
